<template>
  <v-jumbotron color="grey lighten-2">
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h3 class="display-3">
            Bienvenidos <strong>Colegio Herbart</strong>
          </h3>
          <v-divider />
          <v-btn large color="primary" class="mx-0" to="/login" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
</template>

<script>

  export default {
    name: 'Home',
    components: {
    }
  }
</script>
